import React from 'react';
import { FinancialTransaction } from '../../services/database/supabase';

interface TransactionFormProps {
  transaction: Partial<FinancialTransaction>;
  onTransactionChange: (transaction: Partial<FinancialTransaction>) => void;
  onSave: () => void;
  onCancel: () => void;
  isEditing: boolean;
}

export const TransactionForm: React.FC<TransactionFormProps> = ({
  transaction,
  onTransactionChange,
  onSave,
  onCancel,
  isEditing,
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-[#111] rounded-xl p-8 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-6">
          {isEditing ? 'Editar Transação' : 'Nova Transação'}
        </h2>

        <div className="space-y-4">
          <div>
            <label className="block text-sm mb-1">Descrição</label>
            <input
              type="text"
              value={transaction.description || ''}
              onChange={(e) => onTransactionChange({ ...transaction, description: e.target.value })}
              className="w-full bg-[#222] border border-white/10 rounded-lg p-2"
              placeholder="Descrição da transação"
            />
          </div>

          <div>
            <label className="block text-sm mb-1">Valor</label>
            <input
              type="number"
              value={transaction.amount || ''}
              onChange={(e) => onTransactionChange({ ...transaction, amount: parseFloat(e.target.value) })}
              className="w-full bg-[#222] border border-white/10 rounded-lg p-2"
              placeholder="0.00"
              step="0.01"
            />
          </div>

          <div>
            <label className="block text-sm mb-1">Categoria</label>
            <input
              type="text"
              value={transaction.category || ''}
              onChange={(e) => onTransactionChange({ ...transaction, category: e.target.value })}
              className="w-full bg-[#222] border border-white/10 rounded-lg p-2"
              placeholder="Categoria"
            />
          </div>

          <div>
            <label className="block text-sm mb-1">Tipo</label>
            <select
              value={transaction.type || 'Despesas'}
              onChange={(e) => onTransactionChange({ ...transaction, type: e.target.value as any })}
              className="w-full bg-[#222] border border-white/10 rounded-lg p-2"
            >
              <option value="Despesas">Despesas</option>
              <option value="Receita">Receita</option>
              <option value="Salário">Salário</option>
              <option value="Saldo">Saldo</option>
              <option value="Carro">Carro</option>
            </select>
          </div>

          <div>
            <label className="block text-sm mb-1">Proprietário</label>
            <select
              value={transaction.owner || 'Luiz'}
              onChange={(e) => onTransactionChange({ ...transaction, owner: e.target.value as any })}
              className="w-full bg-[#222] border border-white/10 rounded-lg p-2"
            >
              <option value="Luiz">Luiz</option>
              <option value="Empresa">Empresa</option>
            </select>
          </div>

          <div>
            <label className="block text-sm mb-1">Status</label>
            <select
              value={transaction.status || 'Not started'}
              onChange={(e) => onTransactionChange({ ...transaction, status: e.target.value as any })}
              className="w-full bg-[#222] border border-white/10 rounded-lg p-2"
            >
              <option value="Not started">Não iniciado</option>
              <option value="In progress">Em andamento</option>
              <option value="Done">Concluído</option>
            </select>
          </div>

          <div>
            <label className="block text-sm mb-1">Data</label>
            <input
              type="date"
              value={transaction.date || ''}
              onChange={(e) => {
                // Garantir que a data seja salva no formato YYYY-MM-DD sem ajuste de timezone
                const selectedDate = e.target.value;
                onTransactionChange({ ...transaction, date: selectedDate });
              }}
              className="w-full bg-[#222] border border-white/10 rounded-lg p-2"
            />
          </div>

          <div className="flex gap-4 mt-6">
            <button
              onClick={onSave}
              className="flex-1 bg-white text-black h-[48px] rounded-xl font-medium hover:bg-[#F2F2F2] transition-colors"
            >
              {isEditing ? 'Atualizar' : 'Adicionar'}
            </button>
            <button
              onClick={onCancel}
              className="flex-1 bg-white/10 text-white h-[48px] rounded-xl font-medium hover:bg-white/20 transition-colors"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
